import { equipmentTypes } from "@/mocks/serviceVentaData";

export default function EquipmentTypes() {
  return (
    <section className="py-12 md:py-20 px-4 md:px-8 lg:px-12 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center max-w-3xl mx-auto mb-10 md:mb-14 reveal">
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-foreground-400 mb-3 block">
            SERVICIOS
          </span>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-4 leading-snug">
            <span className="text-[#0087a4]">Soluciones</span> Integrales en Climatización, Refrigeración y Ventilación
          </h2>
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
            En <span className="text-[#0087a4] font-semibold">SERIN INGENIERÍA DE PROYECTOS SAS</span>, nos especializamos en el diseño, instalación, mantenimiento y reparación de sistemas de climatización y refrigeración para hogares, empresas e industriales en toda Colombia. Nos aseguramos de ofrecer soluciones eficientes, personalizadas y sostenibles, garantizando ambientes óptimos para cada espacio.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {equipmentTypes.slice(0, 3).map((type, i) => (
            <article
              key={type.name}
              className="reveal relative h-[300px] md:h-[360px] rounded-lg overflow-hidden group cursor-pointer"
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              <img
                src={type.image}
                alt={type.name}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/50 to-foreground-950/20 group-hover:from-foreground-950/95 transition-all duration-500" />
              <div className="absolute inset-0 flex flex-col justify-end p-6 md:p-8">
                <h3 className="font-heading font-bold text-background-50 text-lg md:text-xl leading-tight mb-1">
                  {type.name === "Mini Split" && "Venta de Equipos de Alta Calidad de Marcas Reconocidas"}
                  {type.name === "Cassette" && "Instalación de Aires Acondicionados"}
                  {type.name === "Piso-Techno" && "Mantenimiento para Aires Acondicionados y Cuartos Fríos"}
                  {type.name !== "Mini Split" && type.name !== "Cassette" && type.name !== "Piso-Techno" && type.name}
                </h3>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}